import { types } from 'mobx-state-tree';

/**
 * Orderable entity
 */
export const Ordered = types
    .model('Ordered', {
        sortOrder: types.number
    });
